import { spacing } from 'ext-ui/style/spacing'
import { css } from 'styled-components'

export const workspace = css`
  width: 100%;

  .runError {
    margin-bottom: ${spacing(6)};
  }

  .runStatusAnnouncement {
    border: 0;
    clip-path: inset(50%);
    height: 1px;
    margin: -1px;
    overflow: hidden;
    padding: 0;
    position: absolute;
    white-space: nowrap;
    width: 1px;
  }
`
